export const layoutTokens = {
  fullWidth: {
    width: '100%',
  },
  centeredColumn: {
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
  },
} as const;
